import { useState, useEffect } from 'react';
import { createNewThread, fetchThread } from "../services/api";
import { runFinishedStates } from "./constants";

export const useThread = (run, setRun) => {
    const [threadId, setThreadId] = useState(undefined);
    const [thread, setThread] = useState(undefined);
    const [actionMessages, setActionMessages] = useState([]);
    const [messages, setMessages] = useState([]);

    // Create new thread if one doesn't exist
    useEffect(() => {
        if (threadId === undefined) {
            const localThreadId = localStorage.getItem("thread_id");
            if (localThreadId) {
                console.log(`Resuming thread ${localThreadId}`);
                setThreadId(localThreadId);
                fetchThread(localThreadId).then((data)=>{
                    console.log('data=',data);
                    setThread(data);
                });
            } else {
                console.log("Creating new thread");
                createNewThread().then((data) => {
                    setRun(data);
                    setThreadId(data.thread_id);
                    localStorage.setItem("thread_id", data.thread_id); // Store thread_id in local storage
                    console.log(`Created new thread ${data.thread_id}`);
                });
            }
        }
    }, [threadId, setThreadId, setThread, setRun]);
    

    // Fetch thread after run completes
    useEffect(() => {
        if (run && runFinishedStates.includes(run.status)) {
            console.log(`Retrieving thread ${run.thread_id}`);
            fetchThread(run.thread_id)
                .then((threadData) => {
                    setThread(threadData);
                });
        }
    }, [run, runFinishedStates, setThread]);

    // Transform thread into a list of messages
    useEffect(() => {
        if (thread) {
            let newMessages = [...thread.messages, ...actionMessages]
                .sort((a, b) => a.created_at - b.created_at)
                .filter((message) => message.hidden !== true);
            setMessages(newMessages);
        }
    }, [thread, actionMessages]);

    const clearThread = () => {
        localStorage.removeItem("thread_id");
        setThreadId(undefined);
        setThread(undefined);
        setRun(undefined);
        setMessages([]);
        setActionMessages([]);
    }

    return {
        threadId,
        messages,
        actionMessages,
        setActionMessages,
        clearThread
    };
};
